import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/plugins/loading'

export default {
  async setLookups({ commit, dispatch, state }, keys) {
    let _keys = keys.filter(k => !state.lookups[k])
    if (_keys.length) {
      const r = await startLoading(dispatch, 'setLookups', () =>
        http.post('lookup/ByKeys', keys)
      )
      commit(types.SET_LOOKUPS, [keys, r.data])
    }
  },
  async getLookupsByGroup({ commit, dispatch, state }, { className, group }) {
    const r = await startLoading(dispatch, 'getLookupsByGroup', () =>
      http.get(`lookup/ByGroup?className=${className}&group=${group}`)
    )
    commit(types.SET_GROUPS, r.data)
  },
  async upsertLookup({ commit, dispatch, state }, lookup) {
    const r = await startLoading(dispatch, 'upsertLookup', () =>
      http.post('lookup/Upsert', lookup)
    )
    commit(types.UPSERT_LOOKUP, [lookup, r.data])
    return r
  },
  async deleteLookup({ commit, dispatch, state }, lookup) {
    let _lookup = Object.assign({}, lookup)
    _lookup.isActive = false
    const r = await startLoading(dispatch, 'deleteLookup', () =>
      http.post('lookup/Delete', _lookup)
    )
    if (r.data[0].Results === '') {
      commit(types.DELETE_LOOKUP, lookup)
    }
    return r
  },
  async upsertGroup({ commit, dispatch, state }, { id, name }) {
    let data = {
      id: id,
      text: name
    }
    const r = await startLoading(dispatch, 'deleteLookup', () =>
      http.post('lookup/UpsertGroup', data)
    )
    if (r.data === id) {
      commit(types.UPSERT_GROUP, data)
    }
    return r
  },
  async getLookupValuesZeus({ commit, dispatch }, key) {
    const r = await startLoading(dispatch, 'getLookupValuesZeus', () =>
      http.get(`app/GetLookupValues?key=${key}`)
    )
    commit(types.SET_LOOKUPS_ZEUS, [key, r.data])
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/actions.js